import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { BaseScene } from "./BaseScene";
import { GameIntroScene } from "./GameIntro";
import { DialogOption, GameState } from "../objects/GameState";
import { Character } from "../objects/Character";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.Colony;
        this.mainScene = BaseScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "Colony.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Colony.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Colony.Phaser.HowToPlay.tabletInstructions";
    }

    create() {
        super.create();

        /** JB: Note
         * Required because this game was an early prototype made real
         * This properly loads the gamestate, starting at slide 1 when moving to the next scene
         */
        // Get the first slide and initialize GameState
        var slides = require("../objects/slides.json");
        var startSlide = slides[0];
        var dialog = startSlide.dialogKey;
        var options: DialogOption[] = startSlide.options;
        GameState.current = new GameState(Character.EEBOT, dialog, options);
    }
}



// WEBPACK FOOTER //
// ./src/games/ColonyGame/scenes/IntroductionScene.ts